import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  Tooltip,
  // TextField,
  // Checkbox,
  // ListItemText,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import Editor from "react-simple-wysiwyg";

function TrainingCourse() {
  const pageTitle = "Training Course";
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);

  const [courseTitle, setCourseTitle] = useState(null);
  const [courseDescription, setCourseDescription] = useState(null);
  const [courseMaterials, setCourseMaterials] = useState([]);
  const [quizzes, setQuizzes] = useState([]);

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedMaterialContent, setSelectedMaterialContent] = useState({});
  const [openMaterialContentDialog, setOpenMaterialContentDialog] = useState(false);

  const [materialTitle, setMaterialTitle] = useState(null);
  const [materialContentType, setMaterialContentType] = useState(null);
  const [materialContent, setMaterialContent] = useState(null);
  // const [uploadFile, setUploadFile] = useState(null);
  const [openUploadMaterialDialog, setOpenUploadMaterialDialog] = useState(false);

  const [quizTitle, setQuizTitle] = useState(null);
  const [quizDescription, setQuizDescription] = useState(null);
  const [quizPassMark, setQuizPassMark] = useState(null);
  const [openAddQuizDialog, setOpenAddQuizDialog] = useState(false);

  async function updateStatusQuiz(materialRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/trainings/quizzes/${materialRef}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteQuiz(materialRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/trainings/quizzes/${materialRef}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteMaterial(materialRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/trainings/materials/${materialRef}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  function getContentIcon(record) {
    if (record.material_type === "VIDEO") {
      return "ondemand_video";
    }
    if (record.material_type === "LINK") {
      return "download";
    }
    // if (record.material_type === "FILE") {
    //   return "file_download";
    // }
    if (record.material_type === "TEXT") {
      return "description";
    }

    return "document";
  }

  const tableMaterialsColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Material", accessor: "type", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildMaterialsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        actions: (
          <MDButton
            size="small"
            variant="outlined"
            color="error"
            iconOnly
            onClick={() => {
              if (window.confirm(`Delete?`) === true) {
                deleteMaterial(row.reference);
              }
            }}
          >
            <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
              delete
            </Icon>
          </MDButton>
        ),
        name: row.title,
        type: (
          <Tooltip title="View Material">
            <Icon
              fontSize="large"
              color="info"
              onClick={() => {
                if (["VIDEO", "TEXT"].includes(row.material_type)) {
                  setSelectedMaterialContent(row);
                  setOpenMaterialContentDialog(true);
                } else {
                  window.open(row.material_content, "_blank");
                }
              }}
            >
              {getContentIcon(row)}
            </Icon>
          </Tooltip>
        ),
      });
      return null;
    });

    return rows;
  };

  const tableQuizzesColumns = [
    { Header: "Assessment", accessor: "name", align: "left" },
    { Header: "Pass Mark", accessor: "pass_mark", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Manage", accessor: "action", align: "right" },
  ];

  const buildQuizzesRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        pass_mark: `${row.pass_mark * 100}%`,
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        action: (
          <MDBox>
            <Tooltip title="Manage">
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                onClick={() => {
                  navigate(`/course-quizzes/${row.reference}`);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  east
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title={row.status ? "Disable" : "Enable"}>
              <MDButton
                size="small"
                variant="outlined"
                color={row.status ? "warning" : "success"}
                iconOnly
                onClick={() => {
                  if (window.confirm(`${row.status ? "Disable" : "Enable"} this quiz?`) === true) {
                    updateStatusQuiz(row.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  {row.status ? "pause" : "play_arrow"}
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete?`) === true) {
                  deleteQuiz(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/trainings/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            // console.log(result.data.data);
            setCourseTitle(result.data.data.course.title);
            setCourseDescription(result.data.data.course.description);

            const mrows = buildMaterialsRows(result.data.data.course.materials);
            setCourseMaterials(mrows);

            const qrows = buildQuizzesRows(result.data.data.course.quizzes);
            setQuizzes(qrows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function editCourse() {
    if (courseTitle === null) {
      setSeverity("error");
      setErrMsg("Name is required.");
      setOpen(true);
      return;
    }

    if (courseDescription === null) {
      setSeverity("error");
      setErrMsg("Description is required.");
      setOpen(true);
      return;
    }

    setOpenEditDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      title: `${courseTitle}`,
      description: `${courseDescription}`,
    };

    await axios
      .post("portal/trainings/edit.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const addMaterial = async () => {
    if (materialTitle === null) {
      setSeverity("error");
      setErrMsg("Name is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    if (materialContentType === null) {
      setSeverity("error");
      setErrMsg("Material type is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    // if (["FILE"].includes(materialContentType)) {
    //   if (!uploadFile) {
    //     setSeverity("error");
    //     setErrMsg("Upload file is required");
    //     setOpen(true);
    //     setShowLoading(false);
    //     return;
    //   }
    // }

    if (!["VIDEO", "LINK", "TEXT"].includes(materialContentType)) {
      if (materialContent === null) {
        setSeverity("error");
        setErrMsg("Content is required");
        setOpen(true);
        setShowLoading(false);
        return;
      }
    }

    setOpenUploadMaterialDialog(false);
    setShowLoading(true);

    const json = {
      reference: ref,
      title: `${materialTitle}`,
      content_type: `${materialContentType}`,
      content: materialContent,
    };

    await axios
      .post("portal/trainings/materials/create.json", json)
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  };

  // function fileSelected(e, any = false) {
  //   e.persist();
  //   if (!any) {
  //     const fileTypes = ["pdf", "doc", "jpg", "png", "jpeg"];
  //     const file = e.target.files[0];
  //     const extension = file.name.split(".").pop().toLowerCase();
  //     const supported = fileTypes.indexOf(extension) > -1;
  //     if (!supported) {
  //       setSeverity("error");
  //       setErrMsg("File not supported");
  //       setOpen(true);
  //       return;
  //     }
  //   }

  //   setUploadFile(e.target.files[0]);
  // }

  const addQuiz = async () => {
    if (quizTitle === null) {
      setSeverity("error");
      setErrMsg("Name is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    if (quizDescription === null) {
      setSeverity("error");
      setErrMsg("Description is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    if (quizPassMark === null) {
      setSeverity("error");
      setErrMsg("Pass mark is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    setOpenAddQuizDialog(false);
    setShowLoading(true);

    const json = {
      reference: ref,
      title: `${quizTitle}`,
      description: `${quizDescription}`,
      pass_mark: parseFloat(quizPassMark, 10) / 100,
    };

    await axios
      .post("portal/trainings/quizzes/create.json", json)
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openEditDialog}>
        <DialogTitle>
          <MDBox>Edit Course</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Course Name"
                type="text"
                fullWidth
                variant="outlined"
                value={courseTitle}
                onChange={(e) => setCourseTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <Editor
                value={courseDescription}
                onChange={(e) => setCourseDescription(e.target.value)}
                placeholder="Enter a meaningful description..."
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              editCourse();
            }}
          >
            Update
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openMaterialContentDialog} fullWidth maxWidth="md">
        <DialogContent>
          <MDBox>
            {selectedMaterialContent.material_type === "VIDEO" ? (
              <iframe
                title="Video Tutorial"
                type="text/html"
                width="100%"
                height="480"
                src={selectedMaterialContent.material_content}
                frameBorder="0"
                allowFullScreen
              />
            ) : (
              <MDTypography variant="h6" fontWeight="light">
                <div
                  dangerouslySetInnerHTML={{ __html: selectedMaterialContent.material_content }}
                />
              </MDTypography>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenMaterialContentDialog(false);
            }}
            color="dark"
            variant="outlined"
            iconOnly
            circular
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openUploadMaterialDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Material</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setMaterialTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Material Type</InputLabel>
                <Select
                  label="Material Type"
                  onChange={(e) => {
                    setMaterialContentType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="VIDEO">Video</MenuItem>
                  <MenuItem value="LINK">Download Link</MenuItem>
                  {/* <MenuItem value="FILE">Documents: PDF, DOC, POWERPOINT, IMAGE</MenuItem> */}
                  <MenuItem value="TEXT">Text</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            {materialContentType !== null ? (
              <div>
                {materialContentType === "TEXT" ? (
                  <MDBox mt={3}>
                    <Editor
                      value={materialContent}
                      onChange={(e) => setMaterialContent(e.target.value)}
                      placeholder="Paste text from pdf, word documents or text files..."
                    />
                  </MDBox>
                ) : (
                  <MDBox>
                    {materialContentType === "LINK" ? (
                      // <MDBox mt={4}>
                      //   <TextField
                      //     sx={{ width: "100%" }}
                      //     type="file"
                      //     name="upload_file"
                      //     id="upload_file"
                      //     // onChange={handleFileInputChange}
                      //     onChange={(e) => fileSelected(e, true)}
                      //   />
                      // </MDBox>
                      <MDBox mt={4}>
                        <MDInput
                          placeholder="Enter link to the material"
                          multiline
                          rows={4}
                          name="content"
                          margin="dense"
                          label="Link"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setMaterialContent(e.target.value)}
                          helperText="Download Link to your PDF, Image, Powerpoint or Word files"
                        />
                      </MDBox>
                    ) : (
                      <MDBox mt={4}>
                        <MDInput
                          placeholder="Video link. Ex. Youtube video embedded link, Vimeo etc"
                          multiline
                          rows={4}
                          name="content"
                          margin="dense"
                          label="Link"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setMaterialContent(e.target.value)}
                          helperText="Video link on Youtube, Vimeo etc. Must be an embededed link."
                        />
                      </MDBox>
                    )}
                  </MDBox>
                )}
              </div>
            ) : (
              <> </>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadMaterialDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              addMaterial();
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddQuizDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Assessment</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setQuizTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4}>
              <MDInput
                multiline
                rows={4}
                name="content"
                margin="dense"
                label="Description"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setQuizDescription(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4}>
              <MDInput
                name="title"
                margin="dense"
                label="Pass Mark %"
                type="decimal"
                fullWidth
                variant="outlined"
                onChange={(e) => setQuizPassMark(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddQuizDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              addQuiz();
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mt={1} mb={3}>
        <MDBox>
          <Button
            size="small"
            color="dark"
            startIcon={<Icon>west</Icon>}
            onClick={() => {
              navigate("/trainings");
            }}
          >
            Back To Courses
          </Button>
        </MDBox>
        <MDBox mt={2}>
          <Card sx={{ width: "100%", marginTop: "15px" }}>
            <MDBox p={3}>
              <MDBox display="flex" justifyContent="space-between" alignItems="center">
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                    Course
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light" textTransform="capitalize">
                    {courseTitle}
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <MDButton
                    variant="outlined"
                    color="warning"
                    iconOnly
                    size="small"
                    onClick={() => {
                      setOpenEditDialog(true);
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                  </MDButton>
                </MDBox>
              </MDBox>
              <MDBox mt={5}>
                <MDTypography
                  variant="h6"
                  fontWeight="light"
                  fontSize={12}
                  textTransform="capitalize"
                >
                  Course Outline
                </MDTypography>
                <MDTypography mt={2} fontSize="medium" fontWeight="light">
                  <div dangerouslySetInnerHTML={{ __html: courseDescription }} />
                </MDTypography>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>

        {/* <MDBox mt={5}>
          <Card sx={{ width: "100%", marginTop: "0px" }}>
            <MDBox p={3}>
              <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                Course Outline
              </MDTypography>
              <MDTypography mt={2} fontSize="medium" fontWeight="light">
                <div dangerouslySetInnerHTML={{ __html: courseDescription }} />
              </MDTypography>
            </MDBox>
          </Card>
        </MDBox> */}

        <MDBox mt={5}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
                          <MDBox ml={0} mr={3}>
                            <MDTypography variant="h6" fontWeight="medium">
                              Course Materials
                            </MDTypography>
                          </MDBox>
                          <MDBox>
                            <MDButton
                              variant="outlined"
                              color="dark"
                              iconOnly
                              size="small"
                              onClick={() => {
                                setMaterialContent(null);
                                setMaterialContentType(null);
                                setMaterialTitle(null);
                                setOpenUploadMaterialDialog(true);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                            </MDButton>
                          </MDBox>
                        </MDBox>
                        <MDBox mt={5}>
                          <DataTable
                            table={{ columns: tableMaterialsColumns, rows: courseMaterials }}
                            isSorted
                            canSearch={false}
                            entriesPerPage={false}
                            showTotalEntries
                            noEndBorder
                          />
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MDBox>

        <MDBox mt={5}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={0}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
                          <MDBox ml={0} mr={3}>
                            <MDTypography variant="h6" fontWeight="medium">
                              Assessments
                            </MDTypography>
                          </MDBox>
                          <MDBox>
                            <MDButton
                              variant="outlined"
                              color="dark"
                              iconOnly
                              size="small"
                              onClick={() => {
                                setQuizTitle(null);
                                setQuizDescription(null);
                                setQuizPassMark(null);
                                setOpenAddQuizDialog(true);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                            </MDButton>
                          </MDBox>
                        </MDBox>
                        <MDBox mt={5}>
                          <DataTable
                            table={{ columns: tableQuizzesColumns, rows: quizzes }}
                            isSorted
                            canSearch={false}
                            entriesPerPage={false}
                            showTotalEntries
                            noEndBorder
                          />
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TrainingCourse;
